import { render, staticRenderFns } from "./FormSubTypeBlock.vue?vue&type=template&id=31ca3675&scoped=true&"
import script from "./FormSubTypeBlock.vue?vue&type=script&lang=js&"
export * from "./FormSubTypeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ca3675",
  null
  
)

export default component.exports